import { createSlice } from "@reduxjs/toolkit";
import { AdminDashboardApiPayload } from "types/dashboard.api";
import { AdminUserListApiPayload } from "types/user.api";
import {
  adminDeleteUser,
  adminHome,
  adminUsersList,
  manageDisableUser,
} from "./thunk";
import { PaginationMeta } from "types/ApiResponse";

interface AdminState {
  message: string | null;
  isLoading: boolean;
  success: boolean;
  error: boolean;
  usersList: Array<AdminUserListApiPayload> | null;
  homeData: AdminDashboardApiPayload | null;
  meta: PaginationMeta | null;
}

const initialState: AdminState = {
  homeData: null,
  usersList: [],
  isLoading: false,
  message: null,
  success: false,
  error: false,
  meta: null,
};
const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //Admin Home
    builder
      .addCase(adminHome.pending, (state) => {
        state.isLoading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(adminHome.fulfilled, (state, action) => {
        state.isLoading = false;
        state.homeData = action.payload.payload;
        state.success = true;
      })
      .addCase(adminHome.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.success = false;
      });

    //Admin Users List
    builder
      .addCase(adminUsersList.pending, (state) => {
        state.isLoading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(adminUsersList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.usersList = action.payload.payload.data;
        state.meta = action.payload.payload.meta;
        state.success = true;
      })
      .addCase(adminUsersList.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.success = false;
      });

    //Manage Disable User
    builder
      .addCase(manageDisableUser.pending, (state) => {
        state.isLoading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(manageDisableUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        const id = action.payload.id;

        state.usersList =
          state.usersList?.map((user) =>
            user.id === id ? { ...user, is_active: !user.is_active } : user
          ) || null;
      })
      .addCase(manageDisableUser.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.success = false;
      });

    //Remove User
    builder
      .addCase(adminDeleteUser.pending, (state) => {
        state.isLoading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(adminDeleteUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        const id = action.payload.userId;

        state.usersList =
          state.usersList?.filter((user) => user.id !== id) || null;

        if (state.meta) {
          state.meta.total = state.meta.total - 1;
          state.meta.to = state.meta.to - 1;
          state.meta.last_page = Math.ceil(
            state.meta.total / state.meta.per_page
          );
        }
      })
      .addCase(adminDeleteUser.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.success = false;
      });
  },
});

export default adminSlice.reducer;
